import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { NbDialogService, NbMenuService } from '@nebular/theme';

import { diffChars }  from '../../../template-update/character';

@Component({
    selector: 'app-block-viewer',
    templateUrl: './block-viewer.component.html',
    styleUrls: ['./block-viewer.component.scss'],
    standalone: false
})
export class BlockViewerComponent implements OnInit {

  originalModel;
  _model;
  @Input() set model(model){
    this._model = model;
    this.isStructuredModel();
    this.originalModel = {...model};
  };
  @Input() gameId;
  @Input() templateId;
  @Input() languages;
  @Input() defaultLang;
  @Input() characters;
  @Input() templateAttr;
  @Input() difAttr = 'from';

  isStructuredBlock;

  constructor(private router: Router,
    private dialogService: NbDialogService,
    private menuService: NbMenuService) {
  }

  ngOnInit() {
  }

  isStructuredModel(){
    
    console.log('isStructuredModel:'+this._model);
    //classic text block: {en:'', fr:'', nl:''}
    /*struct block: 
    {
      time: 1679494355708,
      blocks: [
        {
        id: "mhTl6ghSkV",
        type: "paragraph",
        data: {
        text: "Hey. Meet the new Editor. On this picture you can see it in action. Then, try a demo 🤓",
        } ,
      }
    */
    if(this._model && this._model.blocks){
      this.isStructuredBlock = true;
    }
    else{
      this.isStructuredBlock = false;
    }
  }

  getDiffAttributes(from, to){
    if(from && to){
      if(from.length>2000 || to.length>2000){
        return to;
      }
      let diff = diffChars(from, to , {})
      if( diff.length > 1 ){
        return this.setNewColoredAttribut(diff, this.difAttr)
      } else return to
    } else if (!from && to){
      return '<span class="added">'+to + '</span>'
    } else return to
  }

  setNewColoredAttribut(diff, param){
    let att = ''
    for (let i = 0; i < diff.length; i++) {
      const element = diff[i];
      if(!element.removed && !element.added){
        att += element.value 
      }
      if(param === 'to'){
        if(!element.removed && element.added){
          att += '<span class="added">'+ element.value + '</span>'
        }
      }else{
        if(!element.removed && element.added){
          att += '<span class="removed">'+ element.value + '</span>'
        }
      }
    }
    return att
  }

}
